import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { format } from 'date-fns';
import Icon from './Icon';
import { MESSAGES } from '../constants/MaintenanceMessages';
import { VCS_SLUG } from '../constants/api';
class MaintenanceBanner extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            storedBanners: [],
        };
        this.handleCloseBanner = (item) => {
            const { t } = this.props;
            // @ts-expect-error TS2345: Argument of type '(prevState: State) => Record<string, any>'
            this.setState((prevState) => {
                const banners = prevState.storedBanners || [];
                banners.push({
                    id: item.id,
                    name: item.vcs ? VCS_SLUG[item.vcs] : 'all',
                    date: format(new Date(), t('dateTimeLongFormat')),
                });
                return {
                    storedBanners: banners,
                };
            });
            localStorage.setItem('banners', JSON.stringify(this.state.storedBanners));
        };
    }
    UNSAFE_componentWillMount() {
        const localBanners = localStorage.getItem('banners');
        this.setState({
            storedBanners: localBanners ? JSON.parse(localBanners) : [],
        });
    }
    renderVcsSlug(vcs) {
        return VCS_SLUG[vcs].slice(0, 1).toUpperCase() + VCS_SLUG[vcs].slice(1, VCS_SLUG[vcs].length);
    }
    renderVcsType(itemVcs, vcs) {
        return itemVcs
            ? ' ' +
                this.renderVcsSlug(vcs)
            : '';
    }
    render() {
        const { vcs, t, className } = this.props;
        const { storedBanners } = this.state;
        const today = new Date().getTime();
        return (_jsx("div", { className: className, children: MESSAGES.map((item) => {
                const fromDate = item.fromDate.slice(0, item.fromDate.indexOf(' '));
                const toDate = item.toDate.slice(0, item.toDate.indexOf(' '));
                const isShow = new Date(fromDate).getTime() <= new Date(today).getTime();
                const isActual = new Date(toDate).getTime() >= new Date(today).getTime();
                return !isShow || (item.vcs && item.vcs !== vcs) || !isActual ? null : (_jsxs("div", { id: String(item.id), className: clsx('maintenance-banner', 'alert', `alert-${item.severity ? item.severity : 'warning'}`, storedBanners.length && storedBanners.findIndex((banner) => banner.id === item.id) !== -1 && 'd-none'), children: [_jsxs("div", { children: [_jsx(Icon, { name: "exclamation-circle", fixedWidth: true, className: "mr-2" }), _jsx("strong", { children: `${this.renderVcsType(item.vcs, vcs)}: ` }), item.message, item.url ? (_jsxs("small", { children: [' ', "(", _jsx("a", { href: item.url, target: "_blank", rel: "noreferrer", children: t('moreInfoMaintenanceBanner') }), ")"] })) : ('')] }), _jsx(Button, { onClick: () => this.handleCloseBanner(item), size: "sm", color: "link", className: "close", "data-dismiss": "alert", "aria-label": t('close'), children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) })] }));
            }) }));
    }
}
MaintenanceBanner.defaultProps = {
    className: '',
};
export default withTranslation()(MaintenanceBanner);
